const Data = [
  
  {
    key: "1",
    title: "Model 3",
    description: "Order Online for Touchless Delivery",
    backgroundImg: "model-3.jpg",
    leftBtnText: "Custom Order",
    rightBtnText: "Existing inventory",
  },
  {
    key: "2",
    title: "Model Y",
    description: "Order Online for Touchless Delivery",
    backgroundImg: "model-y.jpg",
    leftBtnText: "Custom Order",
    rightBtnText: "Existing inventory",
  },
  {
    key: "3",
    title: "Model S",
    description: "Order Online for Touchless Delivery",
    backgroundImg: "model-s.jpg",
    leftBtnText: "Custom Order",
    rightBtnText: "Existing inventory",
  },
  {
    key: "4",
    title: "Model X",
    description: "Order Online for Touchless Delivery",
    backgroundImg: "model-x.jpg",
    leftBtnText: "Custom Order",
    rightBtnText: "Existing inventory",
  },
  {
    key: "5",
    title: "Solar Panels",
    description: "Lowest Cost Solar Panels in America",
    backgroundImg: "solar-panel.jpg",
    leftBtnText: "Order Now",
    rightBtnText: "Learn More",
  },
  {
    key: "6",
    title: "Solar Roof",
    description: "Produce Clean Energy From Your Roof",
    backgroundImg: "solar-roof.jpg",
    leftBtnText: "Order Now",
    rightBtnText: "Learn More",
  },
  {
    key: "7",
    title: "Accessories",
    description: "",
    backgroundImg: "accessories.jpg",
    leftBtnText: "Shop Now",
  },
];

export default Data;
